import restClient from '../restClient';
import axios from 'axios';

/**
 * Chat API service
 * Handles chat-related API calls
 */

// Chat API için özel axios instance
const chatApiClient = axios.create({
  baseURL: 'http://localhost:3001/api',
});

// Send messages to chat AI API (Agent Backend)
export const sendChatMessage = async (messages, userContext = { id: 1, role: 'admin' }) => {
  try {
    const requestData = {
      messages: messages.map(m => ({
        role: m.sender === 'user' ? 'user' : 'assistant',
        content: m.text
      })),
      user: userContext
    };

    const response = await chatApiClient.post('/chat', requestData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data.response;
  } catch (err) {
    console.error('API Error:', err);
    throw err;
  }
};

